import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'PropCore',
  brandName: 'PropCore',
  description: 'Sistema de agendamento para agentes imobiliários',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Casa à venda',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Agente imobiliário mostrando imóvel',
  },
  testimonials: [
    {
      name: 'Vanessa Martins',
      role: 'Agente Imobiliária',
      text: 'Com o PropCore, agendar visitas aos imóveis ficou muito mais prático e profissional.',
      image: testimonial1,
    },
    {
      name: 'Família Costa',
      role: 'Compradores',
      text: 'Conseguimos marcar visitas a várias casas sem uma única chamada. Processo muito eficiente.',
      image: testimonial2,
    },
    {
      name: 'Imobiliária Sonho',
      role: 'Diretor de Vendas',
      text: 'A nossa equipa de agentes está mais produtiva e os nossos clientes mais satisfeitos.',
      image: testimonial3,
    },
  ],
}

export default config
